export const TEST_STATUS = {
	scheduled: 'scheduled',
	inProgress: 'in progress',
	completed: 'completed',
	notComplete: 'not completed',
	canceled: 'canceled',
};
